import { Container, Box, Grid, Typography, Divider } from '@mui/material';
import moment from 'moment';
import { imgUrl } from 'src/Helpers/utils/Constant';
import traineeLogo from '../../../../../../assets/image/atab-logo3.jpg';
import { ISingleTraineeDraftApplication } from '../types/traineeDraftApplicationTypes';

interface IProps {
  componentRef: React.RefObject<any>;
  singleTraineeDraftApplication: ISingleTraineeDraftApplication;
}

const DraftShortCourseForm = ({
  componentRef,
  singleTraineeDraftApplication,
}: IProps) => {
  return (
    <Box ref={componentRef} mt={2}>
      <Container maxWidth='md'>
        <Box>
          <Box mb={-2} textAlign='center'>
            <img src={traineeLogo} alt='ATAB Logo' width={300} height={80} />
          </Box>
          <p style={{ borderBottom: '2px solid gray' }}></p>
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={9}>
                <Box textAlign='center' ml={13}>
                  <Typography variant='h3'>
                    ATAB Tourism Training Institute (ATTI)
                  </Typography>
                  <Typography fontWeight='bold'>
                    Sattar Center (16th Floor), 30/4, Naya Paltan,
                  </Typography>
                  <Typography fontWeight='bold'>
                    VIP Road, Dhaka-1000. Tel: 02 58314284
                  </Typography>
                  <Typography fontWeight='bold'>
                    Mob: 01882088739 Email: atti.atab@gmail.com
                  </Typography>
                  <Typography variant='h4' mt={2} fontWeight='bold'>
                    ADMISSION FORM (DRAFT)
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3}>
                {singleTraineeDraftApplication?.training_course_application_photo ? (
                  <img
                    style={{
                      height: '180px',
                      width: '170px',
                      borderRadius: '10px',
                      objectFit: 'cover',
                    }}
                    src={`${imgUrl}/${singleTraineeDraftApplication.training_course_application_photo}`}
                    alt='Trainee'
                  />
                ) : (
                  <Box
                    sx={{
                      height: '180px',
                      width: '170px',
                      borderRadius: '10px',
                      border: '1px dashed #ccc',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography variant='caption'>Photo</Typography>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box>
          <Box className='single-trainee-application'>
            <ul>
              <li>
                <span>Name</span>:
                <p>
                  {singleTraineeDraftApplication?.training_course_application_name || 'N/A'}
                </p>
              </li>
              <li>
                <span>Father's Name</span>:
                <p>
                  {singleTraineeDraftApplication?.training_course_application_fathers_name || 'N/A'}
                </p>
              </li>
              <li>
                <span>Mother's Name</span>:
                <p>
                  {singleTraineeDraftApplication?.training_course_application_mothers_name || 'N/A'}
                </p>
              </li>
              <li>
                <span className='form-input'>Date of Birth</span>:
                <p>
                  {singleTraineeDraftApplication?.training_course_application_birthdate
                    ? moment(singleTraineeDraftApplication.training_course_application_birthdate).format('D/MM/YYYY')
                    : 'N/A'}
                </p>
                <span className='second-input'>Nationality</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_nationality || 'N/A'}
                </p>
              </li>
              <li>
                <span>Gender</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_gender || 'N/A'}
                </p>
              </li>
              <li>
                <span className='form-input'>Religion</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_religion || 'N/A'}
                </p>
                <span className='second-input'>Occupation</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_father_occupation || 'N/A'}
                </p>
              </li>
              <li>
                <span className='from-long-text-title'>
                  Last Academic Qualification
                </span>
                :
                <p>
                  {singleTraineeDraftApplication?.training_course_application_last_academic_qualification || 'N/A'}
                </p>
              </li>
              <li>
                <span className='from-long-text-title'>
                  Present/ Mailing Address
                </span>
                :
                <p>
                  {singleTraineeDraftApplication?.training_course_application_present_address || 'N/A'}
                </p>
              </li>
              <li>
                <span className='form-input'>Whatsapp</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_whatsapp_number || 'N/A'}
                </p>
                <span className='second-input'>Email</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_email || 'N/A'}
                </p>
              </li>
              <li>
                <span className='form-input'>Local Guardian Name</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_guardian_name || 'N/A'}
                </p>
                <span className='second-input'>Relation</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_guardian_relation || 'N/A'}
                </p>
              </li>
              <li>
                <span>Address</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_guardian_address || 'N/A'}
                </p>
              </li>
              <li>
                <span className='form-input'>Mobile</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_guardian_phone || 'N/A'}
                </p>
                <span className='second-input'>NID No</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_nid_number || 'N/A'}
                </p>
              </li>
              <li>
                <span>Course</span>:{' '}
                <p>{singleTraineeDraftApplication?.atab_training_course_name || 'N/A'}</p>
              </li>
              <li>
                <span>Source of Information</span>:{' '}
                <p>
                  {singleTraineeDraftApplication?.training_course_application_info_source || 'N/A'}
                </p>
              </li>
            </ul>
          </Box>
        </Box>
        <Typography fontWeight='bold' my={1.5}>
          I hereby agree to abide by the rules and regulations of ATAB Tourism &
          Training Institute. I also agree that the admission fee cannot be
          cancelled and fees are non-refundable and will pay dues in given time
          to avoid discontinuation of classes.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'end',
            marginTop: 5,
          }}
        >
          {singleTraineeDraftApplication?.training_course_application_signature_file && (
            <img
              style={{
                height: '50px',
                width: '190px',
                paddingBottom: '4px',
                objectFit: 'contain',
              }}
              src={`${imgUrl}/${singleTraineeDraftApplication.training_course_application_signature_file}`}
              alt='Signature'
            />
          )}
          <Divider sx={{ width: '25%', height: 1.5, background: '#000' }} />
          <Typography pr={2}>Signature of the student</Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default DraftShortCourseForm;
